import { render, staticRenderFns } from "./AudienceActionForm.vue?vue&type=template&id=08e49bd5&scoped=true"
import script from "./AudienceActionForm.vue?vue&type=script&lang=js"
export * from "./AudienceActionForm.vue?vue&type=script&lang=js"
import style0 from "./AudienceActionForm.vue?vue&type=style&index=0&id=08e49bd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e49bd5",
  null
  
)

export default component.exports